import baseService from 'moodleDir/procollege/lib/vue/default-block-root.vue';

export default {
  routes: [
    {
      path: '/',
      component:baseService,
      name:'baseService'
    },
  ]
};
